<script setup lang="ts">
import {Fence, Flower2, Hammer, Leaf, Shovel, Trees} from "lucide-vue-next";

import "@/assets/styles/service.css";

const services = [
  {
    icon: Trees,
    title: "Gartenpflege",
    text: "Regelmäßige Pflege für gesunde und gepflegte Außenanlagen – vom Rasen bis zur Beetpflege."
  },
  {
    icon: Fence,
    title: "Sichtschutz & Zäune",
    text: "Moderne Sichtschutzlösungen und langlebige Zaunanlagen passend zu Ihrem Grundstück."
  },
  {
    icon: Flower2,
    title: "Pflasterarbeiten",
    text: "Terrassen, Wege und Einfahrten mit hochwertigen Materialien und sauberer Umsetzung."
  },
  {
    icon: Shovel,
    title: "Erd- & Baggerarbeiten",
    text: "Professionelle Vorbereitung für Garten- und Landschaftsprojekte jeder Größe."
  },
  {
    icon: Leaf,
    title: "Hecken & Baumschnitt",
    text: "Fachgerechter Rückschnitt für gesunde Pflanzen und ein gepflegtes Gesamtbild."
  },
  {
    icon: Hammer,
    title: "Individuelle Projekte",
    text: "Maßgeschneiderte Lösungen für private Gärten und gewerbliche Außenbereiche."
  }
];
</script>

<template>

  <section class="services-section" id="services">

    <div class="services-header">

      <span class="section-badge">
        Leistungen
      </span>

      <h2>
        Unsere Leistungen im Überblick
      </h2>

      <p>
        Von der Planung bis zur Umsetzung begleiten wir Ihr Projekt
        zuverlässig und professionell.
      </p>

    </div>

    <div class="services-grid">

      <div
          class="service-card"
          v-for="service in services"
          :key="service.title"
      >

        <div class="service-icon">
          <component :is="service.icon"/>
        </div>

        <h3>{{ service.title }}</h3>

        <p>
          {{ service.text }}
        </p>

      </div>

    </div>

  </section>

</template>

<style scoped>
</style>